module.exports = __webpack_public_path__ + "assets/af92685655f45ea0c886e781d3577001.mp4";